export default {
    
    setUser(state,user){
        state.user=user;
        localStorage.setItem('user',JSON.stringify(user));
        // window.console.log(user);
    },
    setToken(state,token){
        state.token=token;
        localStorage.setItem('token',JSON.stringify(token));
        localStorage.setItem('token_last_set',JSON.stringify(Date.now()));
        // window.console.log(token);
    }, 
    setCurrentSideMenu(state,data){
        state.currentSideMenu=data;
    },
    setNotification(state,data){
        state.alertMessage.msg=data;
    },
    logout(state){
         state.user={};
         state.token="";
         localStorage.removeItem('user');
         localStorage.removeItem('token');
    },

}